/**
 * @generated SignedSource<<b8f90da531065286b0ac7b7abdbff850>>
 * @relayHash df4e6bf907f61a108db3338d5f684311
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81b5555319a4634a2993025edb386f42b5c688704d5c07e0b7c4aa3830bc87df

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OverviewTabQuery$variables = {
  boardPerfEndDate: AGG$DateTime;
  boardPerfStartDate: AGG$DateTime;
  cloudId: string;
  endDate: AGG$DateTime;
  startDate: AGG$DateTime;
  userSetupEndDate: AGG$DateTime;
  userSetupStartDate: AGG$DateTime;
};
export type OverviewTabQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"BoardPerformanceOverviewTile_query" | "LoadTimesOverviewTile_query" | "UserSetupOverviewTile_query">;
  };
};
export type OverviewTabQuery = {
  response: OverviewTabQuery$data;
  variables: OverviewTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardPerfEndDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardPerfStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userSetupEndDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userSetupStartDate"
},
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v8 = {
  "kind": "Literal",
  "name": "isV2",
  "value": true
},
v9 = {
  "type": "SUM"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v12 = {
  "aggregation": {
    "type": "PERCENTILE",
    "value": 0.75
  },
  "alias": "loadTime",
  "name": "vc90"
},
v13 = [
  {
    "concreteType": "JiraCFOMetric",
    "kind": "LinkedField",
    "name": "metric",
    "plural": false,
    "selections": (v11/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "OverviewTabQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "LoadTimesOverviewTile_query"
            },
            {
              "kind": "FragmentSpread",
              "name": "BoardPerformanceOverviewTile_query"
            },
            {
              "kind": "FragmentSpread",
              "name": "UserSetupOverviewTile_query"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "OverviewTabQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v7/*: any*/)
            ],
            "concreteType": "JiraCFOConfigsResult",
            "kind": "LinkedField",
            "name": "cfoConfigs",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraCFOLoadTimeConfig",
                "kind": "LinkedField",
                "name": "loadTimeConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "lowerThreshold"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "higherThreshold"
                  }
                ]
              }
            ]
          },
          {
            "alias": "loadTimeSummary",
            "args": [
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "alias": "apdex_bucket",
                    "name": "metric:apdex_bucket"
                  }
                ]
              },
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "endDate"
              },
              {
                "kind": "Literal",
                "name": "filters",
                "value": [
                  {
                    "dimensionFilter": {
                      "name": "experience:key",
                      "operator": "IN",
                      "values": [
                        "jira.fe.page-load.issue-view",
                        "jira.fe.page-load.issue-view-software",
                        "jira.fe.page-load.issue-view-serviceDesk",
                        "jira.fe.page-load.issue-view-core",
                        "jira.fe.page-load.issue-view-polaris",
                        "jira.fe.page-load.issue-view-platform",
                        "jira.fe.page-load.issue-view-embed",
                        "jira.fe.page-load.issue-view-addon",
                        "jira.fe.page-load.issue-view-unknown",
                        "jira.fe.page-load.issue-view-customer-service",
                        "jira.fe.page-load.classic-board",
                        "jira.fe.page-load.classic-backlog",
                        "jira.fe.page-load.next-gen-board",
                        "jira.fe.page-load.next-gen-backlog",
                        "jira.fe.custom.embedded-issue-view-load"
                      ]
                    }
                  }
                ]
              },
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": (v9/*: any*/),
                    "name": "count"
                  }
                ]
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "startDate"
              }
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOMetricBucketComparison",
                        "kind": "LinkedField",
                        "name": "bucketComparisons",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraCFODimension",
                            "kind": "LinkedField",
                            "name": "dimension",
                            "plural": false,
                            "selections": (v11/*: any*/)
                          },
                          {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "currentMetric",
                            "plural": false,
                            "selections": (v11/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "changePercentage"
                          }
                        ]
                      }
                    ],
                    "type": "JiraCFOLoadTimeMetricSummary"
                  }
                ]
              }
            ]
          },
          {
            "alias": "boardPerformanceSummary",
            "args": [
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "alias": "jira_board_id",
                    "name": "custom:boardId"
                  }
                ]
              },
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "boardPerfEndDate"
              },
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": (v9/*: any*/),
                    "alias": "views",
                    "name": "count"
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "boardPerfStartDate"
              }
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOBoardPerfStats",
                        "kind": "LinkedField",
                        "name": "boardPerfStats",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moderateBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardsCount"
                          }
                        ]
                      }
                    ],
                    "type": "JiraCFOBoardPerformanceMetricSummary"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "after",
                    "value": ""
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 25
                  }
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  }
                ],
                "storageKey": "data(after:\"\",first:25)"
              }
            ]
          },
          {
            "alias": "userSetupSummary",
            "args": [
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "alias": "networkDownlink",
                    "name": "networkDownlink"
                  },
                  {
                    "alias": "httpProtocol",
                    "name": "httpProtocol"
                  },
                  {
                    "alias": "cpus",
                    "name": "telemetry:cpus"
                  },
                  {
                    "alias": "osClassification",
                    "name": "osClassification"
                  }
                ]
              },
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "userSetupEndDate"
              },
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "userSetupStartDate"
              }
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOUserSetupDimensionImpact",
                        "kind": "LinkedField",
                        "name": "dimensionImpacts",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "dimensionName"
                          },
                          {
                            "concreteType": "JiraCFOCohortMetric",
                            "kind": "LinkedField",
                            "name": "fastestCohort",
                            "plural": false,
                            "selections": (v13/*: any*/)
                          },
                          {
                            "concreteType": "JiraCFOCohortMetric",
                            "kind": "LinkedField",
                            "name": "slowestCohort",
                            "plural": false,
                            "selections": (v13/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraCFOCohortMetric",
                        "kind": "LinkedField",
                        "name": "overallFastest",
                        "plural": false,
                        "selections": (v13/*: any*/)
                      },
                      {
                        "concreteType": "JiraCFOCohortMetric",
                        "kind": "LinkedField",
                        "name": "overallSlowest",
                        "plural": false,
                        "selections": (v13/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "fastestSetupEventCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalEventCount"
                      }
                    ],
                    "type": "JiraCFOUserSetupMetricSummary"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "81b5555319a4634a2993025edb386f42b5c688704d5c07e0b7c4aa3830bc87df",
    "metadata": {},
    "name": "OverviewTabQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "43bdf687e9be39a13d349164e03120f5";

export default node;
